<template>
  <div :class="className">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PageTile',

  props: {
    borderType: {
      type: String,
      required: true,
      validator: type => ['line', 'shadow', 'shadow-medium'].includes(type),
    },
  },

  computed: {
    className() {
      if (this.borderType === 'shadow-medium') {
        return 'p-6 shadow-elevation-medium rounded-lg';
      }
      if (this.borderType === 'line') {
        return 'p-6 border border-grey-300 border-solid rounded-md text-sm';
      }
      return 'p-6 shadow-outline rounded-lg text-sm';
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
